export default function DeliverableRenderBrochure({ url }: { url: string }): JSX.Element {
  return (
    <div className=" w-full h-full relative">
      <iframe src={url} className="absolute inset-0 w-full h-full" />
    </div>
  );
}
